import script from "./ow-appointments-form.vue?vue&type=script&setup=true&lang=js"
export * from "./ow-appointments-form.vue?vue&type=script&setup=true&lang=js"

import "./ow-appointments-form.vue?vue&type=style&index=0&id=7ed364d4&lang=scss"
import "./ow-appointments-form.vue?vue&type=style&index=1&id=7ed364d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ed364d4"]])

export default __exports__